import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useGetReviewsQuery } from '../features/api/rest/apiReviewsSlice';
import Error from './Error';
import ReviewsResults from './ReviewsResults';
import Spinner from './Spinner';

function CheckReviewes() {
  const { ean } = useParams();
  const { t } = useTranslation();

  const { count, isLoading, isFetching, isError } = useGetReviewsQuery(
    { ean, mine: false },
    {
      selectFromResult: ({ data }) => ({
        count: data?.count,
      }),
    }
  );

  if (isLoading || isFetching) return <Spinner />;

  if (isError) return <Error />;

  if (count === 0) {
    return <Typography sx={{ mt: 1, fontSize: 18 }}>{t('reviews.notFound')}</Typography>;
  }

  return <ReviewsResults ean={ean} />;
}

export default CheckReviewes;
